import { Box, Button, FormControl, FormControlLabel, FormLabel, Grid, Modal, Radio, TextField, TextareaAutosize, Typography } from '@mui/material'
import React from 'react'
import { useState } from 'react';
import { RxCross1 } from "react-icons/rx";
import CustomButtoncolor from '../custom-button/customColorButton';
// import { sendReminder } from '../../store/crm/pos';
import { sendReminder } from '../../store/crm/pos';
import { useDispatch } from 'react-redux';
import { toast } from 'react-hot-toast';
import { Label } from '@mui/icons-material';
import { BuyWalletPoint, setWallet } from '../../store/crm/crm';
import { useFormik } from 'formik';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Loader from "../loader/loader";
import {successConfirmation} from "../../services/utills";
import { RadioGroup } from '@mui/material';
import Waveloading from '../../pages/loading/Waveloading';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    p: '41px 23px',
    borderRadius:'6px',
    '@media (max-width: 480px)': {
      width: "95%",
      p: '31px 13px',
    },
    gap:"5px"
  };
  const wrapper={
    alignItems:"center",
  }
  const heading={
    fontSize:"18px",
    fontFamily:'helvetica-lt-std-roman',
    fontWeight:'400',
    textAlign:"center",
    width:'100%'

  }
 
  export const inputStyle = {
    background: "#EDF2F7",
    borderRadius: '4px',
    ".MuiOutlinedInput-notchedOutline": {
        borderWidth: "0!important"
    },
    ".MuiInputBase-input": {
        borderColor: " #EDF2F7",
        height: "19px",
        minHeight: 'unset',
        "&:focus": {
            borderColor: "#EDF2F7",
            outline: "none",
            "input": {
                height: '19px'
            }
        },
        "&:hover": {
            borderColor: "#EDF2F7",
            outline: "none",
        }
    }
}
export const btnwrappe ={
  marginTop:"5px",
  display:"flex",
  justifyContent:"flex-end",
  gap:"10px"
  
}
 export const textareaStyle = {

  height: '200px',
  border:"none",
    background: "#EDF2F7",
    borderRadius: '4px',
    outline:"none",
      "&:focus": {
        borderColor: "#EDF2F7",
        outline: "none",
      },
      "&:hover": {
        borderColor: "#EDF2F7",
        outline: "none",
    }
    
};


const BuyWallet= ({ customer_id,reFetchData}) => {
  
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    // //console.log("id get",customerId, bookingId )
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('Cash');
    const [formData, setFormData] = useState({
      amount: '',
      paymentDetails: '',
    });
    const handlePaymentMethodChange = (event) => {
      setSelectedPaymentMethod(event.target.value);
    };

    const validate = (values) => {
        const errors = {};

        if (!values.amount) {
            errors.amount = "amount is required";
        }
        return errors;
    };
   

    const formik = useFormik({

        initialValues: {
          amount: "",
          type: "",
          paymentDetails: ""
        },
        validate,
        onSubmit: async (values) => {
          //console.log(formik.values,customer_id)
            try {
                const finalPayload = {
                  amount:  formik.values.amount,
                  type:  selectedPaymentMethod,
                  ...(selectedPaymentMethod !== 'Cash' && { paymentDetails: formik.values.paymentDetails }),
                  customer_id

                };
                setLoading(true)

                let {payload} = await dispatch(BuyWalletPoint(finalPayload));
                //console.log(payload)
                if (payload?.success ==='true'){
                    toast.success('wallet update successfully');
                    handleClose();
                    reFetchData()
                    setLoading(false)
                }else {
                    setLoading(false)

                    if (payload?.data?.errors){
                        toast.error('Error',payload?.data?.errors || 'Somethings went wrong.','error')
                    }
                }
                handleClose();
            } catch (error) {
                setLoading(false)  
                //console.log('Error wallet update', error);
            }
        },
    });


    const handleCloseModal = () => {
        handleClose();
    };

    return (
        <>
            <CustomButtoncolor
                handleClick={handleOpen}
                mainColor={"#219653"}
                size="md"
                val='Buy Wallet Point'
                style={{ 
                    padding: '7px 5px',
                    fontSize: "18px",
                    minWidth: 'max-content',
                    borderRadius: "6px!important",
                    width: "100%",
                    "@media (minWidth: 420px)": {
                        width: 'auto'
                    },
                }}  
                 
            />
            {loading?<Waveloading fullSize/>:''}
            <Modal
      style={{}}
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid container spacing={1} sx={wrapper}>
          <Grid item lg={12} style={{ display: "flex", justifyContent: "space-between", width: {xs:"95%",sm:"100%"} }}>
            <ArrowBackIosNewIcon onClick={handleCloseModal} />
            <Typography id="modal-modal-title" sx={heading}>
              Buy Wallet Points
            </Typography>
          </Grid>
          <Box style={{ marginTop: '26px', width: "100%", padding: "0px 3px 0px 10px" }}>
            <Grid item lg={12} md={12} sm={12}>
              <FormControl fullWidth> 
                <Typography>Amount</Typography>
                <TextField
                  fullWidth
                  name="amount"                
                  sx={inputStyle}
                  placeholder=""
                  value={formik.values.amount} 
                  onChange={formik.handleChange}            
                  // onBlur={formik.handleBlur}    
                />
                {/* {formik.touched.amount && formik.errors.amount && (
                  <Typography color="error">{formik.errors.amount}</Typography>
                )}  */}
              </FormControl>         
            </Grid>    
            <Grid item lg={12} md={12} sm={12}>
              <Typography style={{ marginTop: "10px" }}>Payment Method</Typography>
              <FormControl> 
                <RadioGroup                     
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={selectedPaymentMethod}
                  onChange={handlePaymentMethodChange}
                  name="radio-buttons-group"
                >
                  <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
                  <FormControlLabel value="E-Transfer" control={<Radio />} label="e-Transfer" />
                  {(selectedPaymentMethod === 'E-Transfer') && (
            <Grid item lg={12} md={12} sm={12}>
              <Box style={{ marginTop: '26px', width: "100%", padding: "0px 3px 0px 10px" }}>
                <FormControl fullWidth>
                  <Typography>
                    e-Transfer/Transaction ID 
                  </Typography>
                  <TextField 
                    fullWidth
                    name="paymentDetails"
                    sx={inputStyle}
                    placeholder=""
                    value={formik.values.paymentDetails}
                    onChange={formik.handleChange}
                    // onBlur={formik.handleBlur}
                  />
                  {/* {formik.touched.paymentDetails && formik.errors.paymentDetails && (
                    <Typography color="error">{formik.errors.paymentDetails}</Typography>
                  )} */}
                </FormControl>
              </Box>
            </Grid>
          )}
                  <FormControlLabel value="Card" control={<Radio />} label="Credit/Debit Card (External device)" />
                  {(selectedPaymentMethod === 'Card') && (
            <Grid item lg={12} md={12} sm={12}>
              <Box style={{ marginTop: '20px', width: "100%", padding: "0px 3px 0px 10px"}}>
                <FormControl fullWidth>
                  <Typography>
                  Transaction ID/Card Number
                  </Typography>
                  <TextField
                    fullWidth
                    name="paymentDetails"
                    sx={inputStyle}
                    placeholder=""
                    value={formik.values.paymentDetails}
                    onChange={formik.handleChange}
                    // onBlur={formik.handleBlur}
                  />
                  {/* {formik.touched.paymentDetails && formik.errors.paymentDetails && (
                    <Typography color="error">{formik.errors.paymentDetails}</Typography>
                  )} */}
                </FormControl>
              </Box>
            </Grid>
          )}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Box>
      
    
        </Grid>

        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          sx={{ ...btnwrappe, mt: "24px" }}                 
        >
          <CustomButtoncolor
            mainColor={"#4F4F4F"}
            size="md"
            val='Close'
            style={{
              padding: '7px 5px',
              fontSize: "18px",
              minWidth: 'max-content',
              borderRadius: "6px!important",
              width: "15%",
              "@media (minWidth: 420px)": {
                width: 'auto'
              },
            }}
            handleClick={handleCloseModal}
          />
        <Button  variant="contained"  size="large"
   style={{height:"50px",width:"92px",
   backgroundColor:'linear-gradient(180deg, #72D5FF -43.75%, #0496FF 86.52%)',
   borderRadius:'8px'}}  onClick={formik.handleSubmit}>
         ok
       </Button>   
        </Grid>
      </Box>
    </Modal>   
        </>
    )
}

export default BuyWallet;

